var fileHost = "https://routuantuan.oss-cn-hangzhou.aliyuncs.com/"; //你的oss地址
var config = {
  //aliyun OSS config
  uploadImageUrl: `${fileHost}`,
  AccessKeySecret: '', //登录oss控制台查看
  OSSAccessKeyId: '', //登录oss控制台查看
  SecurityToken: '', // 使用STS签名必传
  timeout: 86400
};
module.exports = config